/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import PageHeader from "../../../components/PageHeader";

import AdministrativeCertificateList from "../../../components/TaxPortal/AdministrativeCertificate/AdministrativeCertificateList";
import { isManagerCompany } from "../../../utils/auth";
import TaxContacts from "../../../components/TaxPortal/TaxContacts";

const AdministrativeCertificate = (props) => {
  return (
    <div className="tax-portal">
      <PageHeader title={`민원증명`} />
      {isManagerCompany() && <TaxContacts />}
      <AdministrativeCertificateList />
    </div>
  );
};

export default AdministrativeCertificate;
